import Vue from 'vue'
import Vuex from 'vuex'

import demo from './store/demo'
import aida from './store/aida'

import settings from 'whitebox-presentation/src/store/settings'
import profile from 'whitebox-presentation/src/store/profile'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		demo,
		aida,
		profile,
		settings,
	},
})
